import { create } from "zustand";

export interface PDASidebarStore {
  isOpen: boolean;
  openSidebar: () => void;
  closeSidebar: () => void;
  toggleSidebar: () => void;
}

/**
 * PDA 사이드바 상태 관리 스토어
 */
const usePDASidebarStore = create<PDASidebarStore>((set) => ({
  isOpen: false,
  openSidebar: () => set({ isOpen: true }),
  closeSidebar: () => set({ isOpen: false }),
  toggleSidebar: () => set((state) => ({ isOpen: !state.isOpen })),
}));

export default usePDASidebarStore;






